import React, { useState, useEffect } from 'react';
import { Bell, FileText, X, ChevronRight, Clock } from 'lucide-react';

const AutoMissionModal = () => {
  const [notifications, setNotifications] = useState([]);
  const [showPanel, setShowPanel] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchNotifications();
    // Actualiser toutes les 30 secondes
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await fetch('    https://vmi1977988.contaboserver.net/api2/admin/fiches-mission', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();

      if (data.success) {
        // Filtrer seulement les fiches "Soumis" (en attente)
        const fichesEnAttente = (data.data || [])
          .filter(fiche => fiche.statut === 'Soumis')
          .slice(0, 10); // Limiter à 10 dernières notifications

        setNotifications(fichesEnAttente);
      }
    } catch (err) {
      console.error('Erreur chargement notifications:', err);
    } finally {
      setLoading(false);
    }
  };

  const allerVersPage = () => {
    window.location.href = '/admin/fiches-mission';
  };

  const nonLues = notifications.length;

  const formatDate = (date) => {
    const maintenant = new Date();
    const notifDate = new Date(date);
    const diffMs = maintenant - notifDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'À l\'instant';
    if (diffMins < 60) return `Il y a ${diffMins} min`;
    if (diffHours < 24) return `Il y a ${diffHours}h`;
    if (diffDays < 7) return `Il y a ${diffDays}j`;
    return notifDate.toLocaleDateString('fr-FR');
  };

  const formatPeriode = (dateDepart, dateRetour) => {
    const debut = new Date(dateDepart);
    const fin = new Date(dateRetour);

    const optionsDebut = { day: 'numeric', month: 'short' };
    const optionsFin = { day: 'numeric', month: 'short' };

    return `${debut.toLocaleDateString('fr-FR', optionsDebut)} → ${fin.toLocaleDateString('fr-FR', optionsFin)}`;
  };

  return (
    <div style={{ position: 'relative' }}>
      {/* Bouton Bell avec badge */}
      <button
        onClick={() => setShowPanel(!showPanel)}
        style={{
          position: 'relative',
          background: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '0.5rem',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
        onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
      >
        <Bell size={20} style={{ color: nonLues > 0 ? '#3b82f6' : '#6b7280' }} />
        {nonLues > 0 && (
          <span style={{
            position: 'absolute',
            top: '-4px',
            right: '-4px',
            background: '#ef4444',
            color: 'white',
            fontSize: '0.625rem',
            fontWeight: '600',
            borderRadius: '9999px',
            padding: '0.125rem 0.375rem',
            minWidth: '18px',
            height: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid white'
          }}>
            {nonLues > 9 ? '9+' : nonLues}
          </span>
        )}
      </button>

      {/* Panel des notifications */}
      {showPanel && (
        <>
          {/* Overlay */}
          <div
            onClick={() => setShowPanel(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'transparent',
              zIndex: 998
            }}
          />

          {/* Panel */}
          <div style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: 0,
            width: '420px',
            maxWidth: '90vw',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05)',
            zIndex: 999,
            maxHeight: '500px',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {/* Header */}
            <div style={{
              padding: '1rem',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <h3 style={{
                  margin: 0,
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#1f2937'
                }}>
                  Ordres de Mission
                </h3>
                <p style={{
                  margin: '0.25rem 0 0 0',
                  fontSize: '0.75rem',
                  color: '#6b7280'
                }}>
                  {nonLues > 0 ? `${nonLues} en attente de validation` : 'Aucune mission en attente'}
                </p>
              </div>
              <button
                onClick={() => setShowPanel(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '0.25rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#6b7280'
                }}
              >
                <X size={20} />
              </button>
            </div>

            {/* Liste des notifications */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '0.5rem'
            }}>
              {loading ? (
                <div style={{
                  padding: '2rem',
                  textAlign: 'center',
                  color: '#6b7280'
                }}>
                  Chargement...
                </div>
              ) : notifications.length === 0 ? (
                <div style={{
                  padding: '2rem',
                  textAlign: 'center'
                }}>
                  <Bell size={40} style={{ color: '#d1d5db', marginBottom: '0.5rem' }} />
                  <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: 0 }}>
                    Aucune mission en attente
                  </p>
                </div>
              ) : (
                notifications.map((notif) => (
                  <div
                    key={notif._id}
                    onClick={allerVersPage}
                    style={{
                      background: '#eff6ff',
                      padding: '0.875rem',
                      borderRadius: '8px',
                      marginBottom: '0.5rem',
                      cursor: 'pointer',
                      border: '1px solid #bfdbfe',
                      transition: 'all 0.2s',
                      position: 'relative'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#dbeafe';
                      e.currentTarget.style.transform = 'translateX(-2px)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(59, 130, 246, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = '#eff6ff';
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    {/* Indicateur */}
                    <div style={{
                      position: 'absolute',
                      left: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      background: '#3b82f6'
                    }} />

                    <div style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '0.75rem',
                      paddingLeft: '1rem'
                    }}>
                      {/* Icône */}
                      <div style={{
                        width: '38px',
                        height: '38px',
                        borderRadius: '8px',
                        background: '#dbeafe',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}>
                        <FileText size={20} style={{ color: '#3b82f6' }} />
                      </div>

                      {/* Contenu */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          gap: '0.5rem',
                          marginBottom: '0.375rem'
                        }}>
                          <h4 style={{
                            margin: 0,
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            color: '#1f2937',
                            lineHeight: '1.25'
                          }}>
                            {notif.commercial?.nom || 'Commercial'}
                          </h4>
                          <ChevronRight size={16} style={{
                            color: '#3b82f6',
                            flexShrink: 0
                          }} />
                        </div>

                        <p style={{
                          margin: '0 0 0.375rem 0',
                          fontSize: '0.8125rem',
                          color: '#374151',
                          lineHeight: '1.4',
                          fontWeight: '500'
                        }}>
                          {notif.natureMission}
                        </p>

                        <p style={{
                          margin: '0 0 0.5rem 0',
                          fontSize: '0.75rem',
                          color: '#6b7280',
                          lineHeight: '1.4'
                        }}>
                          📍 {notif.villesDeplacement?.join(', ') || 'Non spécifié'}
                        </p>

                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '0.5rem',
                          marginTop: '0.5rem'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem'
                          }}>
                            <Clock size={12} style={{ color: '#9ca3af' }} />
                            <span style={{
                              fontSize: '0.6875rem',
                              color: '#9ca3af'
                            }}>
                              {formatDate(notif.createdAt)}
                            </span>
                          </div>

                          {notif.dateDepart && notif.dateRetour && (
                            <span style={{
                              fontSize: '0.6875rem',
                              color: '#6b7280',
                              background: '#f3f4f6',
                              padding: '0.125rem 0.5rem',
                              borderRadius: '4px'
                            }}>
                              {formatPeriode(notif.dateDepart, notif.dateRetour)}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Footer */}
            {notifications.length > 0 && (
              <div style={{
                padding: '0.875rem',
                borderTop: '1px solid #e5e7eb',
                textAlign: 'center'
              }}>
                <button
                  onClick={allerVersPage}
                  style={{
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '0.5rem 1rem',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    width: '100%',
                    justifyContent: 'center'
                  }}
                >
                  Voir toutes les missions ({nonLues})
                  <ChevronRight size={16} />
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AutoMissionModal;